@if (errorKeys) {
  <ul class="list-unstyled warning">
    @for (errorKey of errorKeys; track errorKey) {
      <li>
        @if (errorTranslations[errorKey]; as key) {
          <span [innerHtml]="key | translate"> </span>
        } @else {
          {{ errorKey }}
        }
      </li>
    }
  </ul>
}
